export default __webpack_public_path__ + "static/media/forest_header_with_crown.1a68e7cb.png";